package kz.dentalcrm.app.theme

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.material.ripple.RippleAlpha
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.LocalRippleConfiguration
import androidx.compose.material3.RippleConfiguration
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.ReadOnlyComposable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import kz.dentalcrm.app.core.ui.window.WindowSize


object DefaultTheme {
    val windowsSize: WindowSize
        @ReadOnlyComposable
        @Composable
        get() = WindowSize.COMPACT

    val typography: ThemeTypography
        @Composable
        get() = Typography()

    val colors: ThemeColor
        @ReadOnlyComposable
        @Composable
        get() =
            if (isSystemInDarkTheme())
                LocalDarkColor.current
            else
                LocalLightColor.current

    val offset: Offset
        @ReadOnlyComposable
        @Composable
        get() = LocalThemeOffset.current
    val spacing: Spacing
        @ReadOnlyComposable
        @Composable
        get() = LocalThemeSpacing.current
    val borders: Borders
        @ReadOnlyComposable
        @Composable
        get() = LocalThemeBorders.current
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun AppTheme(
    windowsSize: WindowSize = DefaultTheme.windowsSize,
    typography: ThemeTypography = DefaultTheme.typography,
    borders: Borders = DefaultTheme.borders,
    offset: Offset = DefaultTheme.offset,
    spaces: Spacing = DefaultTheme.spacing,
    darkTheme: Boolean = isSystemInDarkTheme(),
    content: @Composable () -> Unit,
) {
    val systemIsDark = isSystemInDarkTheme()
    val isDarkState = remember { mutableStateOf(systemIsDark) }
    val currentColor = remember { if (darkTheme) DarkColorScheme else LightColorScheme }

    @OptIn(ExperimentalMaterial3Api::class)
    val rippleConfiguration = RippleConfiguration(
        color = DefaultTheme.colors.defaultRipple,
        rippleAlpha = RippleAlpha(0.2f, 0.2f, 0.2f, 0.2f)
    )

    CompositionLocalProvider(
        LocalRippleConfiguration provides rippleConfiguration,
        LocalWindowSize provides windowsSize,
        LocalThemeColors provides currentColor,
        LocalThemeBorders provides borders,
        LocalThemeOffset provides offset,
        LocalThemeSpacing provides spaces,
    ) {

        val isDark by isDarkState
        content()
    }
}